/**
 * Returns "{original} (Copy)" if not in siblings; otherwise increments
 * "(Copy 2)", "(Copy 3)" until unique. Case-insensitive comparison.
 *
 * Mirrors backend GetUniqueDuplicateName so frontend in-form duplicate
 * (Options) behaves identically to server-side duplicates.
 */
export const nextCopyName = (original, siblings = []) => {
  const taken = new Set(
    (siblings || []).map((s) => (s || '').toLowerCase()),
  );
  let candidate = `${original} (Copy)`;
  if (!taken.has(candidate.toLowerCase())) return candidate;
  let n = 2;
  while (taken.has(candidate.toLowerCase())) {
    candidate = `${original} (Copy ${n})`;
    n++;
  }
  return candidate;
};
